import { X } from "lucide-react";
import suporterImage from "@/assets/images/sponsorship/suporter.png";

type Props = { onClose: () => void };

// Header clair violet pastel — l'inverse chromatique du header sombre du
// wizard pronostics, aligné sur la direction « scène illustrée festive ».
export const WizardHeader = ({ onClose }: Props) => (
  <div className="relative h-36 w-full overflow-hidden bg-violet-100 dark:bg-violet-950 md:h-44">
    <div aria-hidden className="pointer-events-none absolute -top-10 -left-8 size-40 rounded-full bg-white/60 blur-3xl dark:bg-violet-800/40" />
    <div aria-hidden className="pointer-events-none absolute -bottom-12 right-1/3 size-44 rounded-full bg-emerald-200/50 blur-3xl dark:bg-emerald-900/30" />
    <div className="absolute inset-x-0 top-0 flex h-full items-center px-6 md:px-8">
      <p className="max-w-[65%] text-xl font-bold text-violet-900 dark:text-violet-100 md:text-2xl">
        Bienvenue dans le parrainage Yeati
      </p>
    </div>
    <img
      src={suporterImage}
      alt=""
      aria-hidden
      className="pointer-events-none absolute -bottom-6 right-2 h-40 select-none drop-shadow-2xl md:-bottom-8 md:right-6 md:h-48"
    />
    <button
      type="button"
      onClick={onClose}
      aria-label="Fermer"
      className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white text-gray-900 ring-1 ring-black/10 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-600"
    >
      <X size={18} />
    </button>
  </div>
);

WizardHeader.displayName = "WizardHeader";
